<template>
  <div class="change-language">
    <span>{{lange == 'en' ? 'Language switching' : '语言切换'}}:</span>
    <el-switch
      v-model="languageFlag"
      active-color="#13ce66"
      inactive-color="#13ce66"
      active-text="English"
      @change="change"
      inactive-text="中文"
    ></el-switch>
  </div>
</template>

<script>
export default {
  name: "ChangeLanguage",
  data() {
    return {
      languageFlag: false,
      clickFlag: false,
      lange: "zh",
    };
  },
  methods: {
    change(res) {
      let confirmText = "切换语言会重新加载页面";
      if (this.$lange == "en") {
        confirmText = "Change language will reload web";
      }
      this.$confirm(confirmText, "", {
        confirmButtonText: this.$lange == "en" ? "Yes" : "确定",
        cancelButtonText: this.$lange == "en" ? "No" : "取消",
        type: "warning",
      })
        .then(() => {
          if (this.clickFlag) {
            // this.languageFlag = !res;
            return this.$message({
              type: "warning",
              message: "请勿频繁操作",
            });
          }
          this.clickFlag = true;
          setTimeout(() => {
            this.clickFlag = false;
          }, 1000);
          this.$lange = res ? "en" : "zh";
          this.ccRequest
            .do("mgr/updateLanguage", { language: this.$lange }, "GET")
            .then((res) => {});
          localStorage.setItem("lange", this.$lange);
          this.lange = localStorage.getItem("lange");
          // location.href="http://47.106.120.55/";
          //   location.href = location.href;
        })
        .catch((res) => {
          this.languageFlag = !this.languageFlag;
        });
    },
  },
  mounted() {
    this.$lange === "en" ? (this.languageFlag = true) : false;
    this.lange = this.$lange;
  },
};
</script>

<style scoped lang="scss">
.change-language {
  display: flex;
  align-items: center;
  padding: 20px;
  > span {
    font-size: 18px;
    color: #6f6f6f;
    margin-right: 10px;
  }
}
</style>
